import React, { useEffect, useState } from "react";
import { Bar, Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend, ArcElement, Title } from "chart.js";
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend, ArcElement, Title);

export default function ScreeningCoverage({ apiUrl = "/api/ncd/screening-coverage" }) {
	const [data, setData] = useState(null);
	useEffect(() => {
		let mounted = true;
		(async () => {
			try {
				const res = await fetch(apiUrl, { cache: 'no-store' });
				if (!res.ok) throw new Error();
				const json = await res.json();
				if (!mounted) return;
				setData(json);
			} catch (e) {
				setData({
					coverage_by_group: [
						{ name: "0-18 yrs", value: 10 },
						{ name: "18-29 yrs", value: 60 },
						{ name: "30-44 yrs", value: 72 },
						{ name: "45-59 yrs", value: 80 },
						{ name: "60+ yrs", value: 65 },
					],
					facility_performance: [
						{ facility: "PHC-01", screened: 220 },
						{ facility: "PHC-02", screened: 340 },
						{ facility: "CHC-01", screened: 180 },
						{ facility: "DH-01", screened: 410 },
					],
					gender_split: { male: 55, female: 45 }
				});
			}
		})();
		return () => mounted = false;
	}, [apiUrl]);

	const ageGroupData = {
		labels: (data?.coverage_by_group || []).map(g => g.name),
		datasets: [{ label: "% Screened", data: (data?.coverage_by_group || []).map(g => g.value), backgroundColor: "#5e72e4", borderRadius: 6 }]
	};
	const ageGroupOptions = { maintainAspectRatio: false,responsive: true,indexAxis: 'y', plugins: {  datalabels: false, legend: { display: false }, tooltip: { enabled: true } }, scales: { x: { beginAtZero: true, grid: { display: false }, ticks: { color: "#525f7f" } }, y: { ticks: { color: "#525f7f" }, grid: { display: false } } } };

	const facilityData = {
		labels: (data?.facility_performance || []).map(f => f.facility),
		datasets: [{ label: "Screened", data: (data?.facility_performance || []).map(f => f.screened), backgroundColor: "#11cdef", borderRadius: 6 }]
	};
	const facilityOptions = {maintainAspectRatio: false,responsive: true, plugins: { datalabels: false,  legend: { display: false }, tooltip: { enabled: true } }, scales: { x: { ticks: { color: "#525f7f" }, grid: { display: false } }, y: { beginAtZero: true, grid: { borderDash: [3, 3] }, ticks: { color: "#525f7f" } } } };

	const genderData = { labels: ["Male", "Female"], datasets: [{ data: [data?.gender_split?.male || 0, data?.gender_split?.female || 0], backgroundColor: ["#5e72e4", "#f5365c"], borderWidth: 2 }] };
	const genderOptions = {  maintainAspectRatio: false,responsive: true,plugins: { datalabels: false, legend: { position: 'bottom', labels: { color: "#525f7f", boxWidth: 10 } }, tooltip: { enabled: true } }, cutout: "70%" };

	return (
		<div className="row gx-3">
			<div className="col-5" style={{ minHeight: 240 }}>
				<div className="card shadow-sm border-0 h-100">
					<div className="card-body p-2">
						<h6 className="text-gray-800 font-semibold fs-6 mb-2">% of Population Screened (by Age Group)</h6>
						<div style={{ height: 200 }}><Bar data={ageGroupData} options={ageGroupOptions} /></div>
					</div>
				</div>
			</div>

			<div className="col-4" style={{ minHeight: 240 }}>
				<div className="card shadow-sm border-0 h-100">
					<div className="card-body p-2">
						<h6 className="text-gray-800 font-semibold fs-6 mb-2">Facility-Level Screening</h6>
						<div style={{ height: 200 }}><Bar data={facilityData} options={facilityOptions} /></div>
					</div>
				</div>
			</div>

			<div className="col-3" style={{ minHeight: 240 }}>
				<div className="card shadow-sm border-0 h-100">
					<div className="card-body p-2 d-flex flex-column">
						<h6 className="text-gray-800 font-semibold fs-6 mb-2">Gender-Wise Screening</h6>
						<div style={{ height: 200}}><Doughnut data={genderData} options={genderOptions} /></div>
					</div>
				</div>
			</div>
		</div>
	);
}
